module.exports = __webpack_public_path__ + "static/media/3.7e057664.jpg";